import { ButtonLink, ButtonProps } from '@sbab-ui/components'

export interface ButtonConfig {
  href: string
  text: string
  variant?: ButtonProps['variant']
}

export interface ButtonConfigWithId extends ButtonConfig {
  id: number
}

interface Props {
  variant?: ButtonProps['variant']
  className?: string
  text: string
  key?: number
  href: string
}

export default function CustomButton({
  variant = 'primary',
  className = 'w-full sm:w-auto mb-10 sm:px-1 sm:mr-3',
  text,
  href,
}: Readonly<Props>) {
  return (
    <ButtonLink
      href={href}
      variant={variant}
      className={className}
      size="large"
      data-cy={`cta-btn-${variant}`}
      data-button-identifier={'savings-calculator-app-' + variant}
    >
      {text}
    </ButtonLink>
  )
}
